export default state => id => {
    let item = state.items.filter(i => {
        return i.value === id;
    })[0];
    return item ? item.iso : '';
}